<template>
  <div class="d-flex flex-column wrapper gap-1">
    <span class="font-weight-bold">Pontuação</span>
    <div class="d-flex flex-row align-center">
      <template v-if="!!showScore">
        <div>
          <h1 class="text-h3" :style="{ color: currentColor }" data-cy="score">{{ score ?? '-' }}</h1>
        </div>
        <div class="vertical-rule"></div>
      </template>
      <div>
        <h2
          v-for="(label, index) in labels"
          :data-cy="`label${index}`"
          :key="label.text"
          class="text-body-2"
          :class="{ highlighted: label.highlightFn(score) }"
          :style="{ color: getHighlightColor(label, score) }"
        >
          {{ label.text }}
        </h2>
      </div>
    </div>
  </div>
</template>

<script>
import { PropOptions } from 'vue'

/**
 * @typedef {Object} ScoreBoardLabelProp
 * @property {string} text
 * @property {(...args: any[]) => boolean} highlightFn
 * @property {string} highlightColor
 */

export default {
  name: 'ScoreBoard',
  props: {
    /** @type {PropOptions<ScoreBoardLabelProp[]>} */
    labels: {
      type: Array,
      required: true,
    },
    score: {
      type: Number,
    },
    showScore: {
      type: Boolean,
      default: true,
    },
  },
  data() {
    return {
      currentColor: '#808080',
      defaultColor: '#808080',
    }
  },
  methods: {
    getHighlightColor(label, score) {
      const isHighlighted = label.highlightFn(score)
      if (isHighlighted) {
        this.currentColor = label.highlightColor
        return label.highlightColor
      }
      return this.defaultColor
    },
  },
}
</script>

<style scoped>
.vertical-rule {
  display: flex;
  align-items: center;
  height: 48px;
  width: 2px;
  background-color: #e6e6e6;
  margin: 0 24px;
}
.wrapper {
  min-height: 80px;
}
.highlighted {
  font-size: 1rem;
  font-weight: 500;
}
</style>
